<template>
	<div class="product-form">
		<div class="mx-5">
			<v-form ref="generalForm" v-model="generalFormValid">
				<v-row no-gutters class="mt-7" v-if="!isExternalEntity">
					<b v-translate>Type:</b>
					<v-btn-toggle class="ml-2" v-model="type" mandatory>
						<v-btn value="classic" small class="text-overline" :disabled="edit">
							<translate>Classic</translate>
						</v-btn>
						<v-btn value="provider" small class="text-overline" :disabled="edit">
							<translate>Provider</translate>
						</v-btn>
					</v-btn-toggle>
					<template v-if="!admin">
						<v-alert v-model="success" color="alert" type="success" class="ml-3">
							<translate>Saved Successfully</translate>
						</v-alert>
						<v-alert v-model="error" color="red" type="error" class="ml-3">
							<translate>Error</translate>
						</v-alert>
					</template>
				</v-row>
				<v-row no-gutters v-if="admin || isExternalEntity" class="mt-2">
					<b v-translate>Language:</b>
					<v-btn-toggle class="ml-2" v-model="language" mandatory>
						<v-btn value="pt" small class="text-overline" key="pt">
							<strong class="mr-1">PT</strong>
							<span v-translate>Portuguese</span>
						</v-btn>
						<v-btn value="en" small class="text-overline" key="en">
							<strong class="mr-1">EN</strong>
							<span v-translate>English</span>
						</v-btn>
						<v-btn value="es" small class="text-overline" key="es">
							<strong class="mr-1">ES</strong>
							<span v-translate>Spanish</span>
						</v-btn>
					</v-btn-toggle>
					<v-spacer></v-spacer>
					<v-alert v-model="success" color="alert" type="success">
						<translate>Saved Successfully</translate>
					</v-alert>
					<v-alert v-model="error" color="red" type="error">
						<translate>Error</translate>
					</v-alert>
				</v-row>
				<v-row no-gutters v-if="admin || isExternalEntity">
					<v-checkbox
						v-model="product.revision"
						color="primary"
						:label="$gettext('Rever')"
						class="mt-0 pb-0"
						hide-details
					/>
					<v-checkbox
						v-model="product.discontinued"
						color="primary"
						:label="$gettext('Discontinued')"
						class="mt-0 pb-0 ml-2"
						hide-details
					/>
					<v-checkbox
						v-model="product.visible"
						color="primary"
						:label="$gettext('Visible')"
						class="mt-0 pb-0 mx-2"
						hide-details
					/>
					<v-btn
						v-if="!edit"
						small
						class="text-overline mt-1 ml-1"
						color="primary"
						@click="showImportProduct = !showImportProduct"
						:loading="saving"
					>
						<span v-translate>Import Formula</span>
					</v-btn>
					<v-row v-if="showImportProduct" no-gutters>
						<v-col cols="12" md="8" class="px-2">
							<SearchProducts context="new-product" type="formula" method="get" @click="importProduct" />
						</v-col>
					</v-row>
				</v-row>
				<v-row no-gutters class="mt-4">
					<v-col cols="12" md="12">
						<v-card>
							<v-card-title class="primary--text" v-translate>General</v-card-title>
							<v-card-text>
								<v-row no-gutters>
									<v-col cols="12" md="4">
										<v-text-field
											v-if="admin || isExternalEntity"
											:rules="requiredRule"
											v-model="product.information[language].name"
											:label="$gettext('Name')"
											outlined
											class="px-2"
										></v-text-field>
										<v-text-field
											v-else
											:rules="requiredRule"
											v-model="product.name"
											:label="$gettext('Name')"
											outlined
											class="px-2"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="4">
										<v-text-field
											v-if="admin || isExternalEntity"
											v-model="product.information[language].translation"
											:label="$gettext('Translation')"
											outlined
											class="px-2"
										></v-text-field>
										<v-text-field
											v-else
											v-model="product.translation"
											:label="$gettext('Translation')"
											outlined
											class="px-2"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="4">
										<v-text-field
											v-if="admin || isExternalEntity"
											v-model="product.information[language].sub_category"
											:label="$gettext('Sub-Category')"
											outlined
											class="px-2"
										></v-text-field>
										<v-text-field
											v-else
											v-model="product.sub_category"
											:label="$gettext('Sub-Category')"
											outlined
											class="px-2"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="4">
										<v-text-field
											v-if="admin || isExternalEntity"
											v-model="product.information[language].pattern"
											:label="$gettext('Pattern')"
											outlined
											class="px-2"
										></v-text-field>
										<v-text-field
											v-else
											v-model="product.pattern"
											:label="$gettext('Pattern')"
											outlined
											class="px-2"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="4">
										<v-text-field
											v-if="admin || isExternalEntity"
											v-model="product.information[language].actions"
											:label="$gettext('Actions')"
											outlined
											class="px-2"
										></v-text-field>
										<v-text-field
											v-else
											v-model="product.actions"
											:label="$gettext('Actions')"
											outlined
											class="px-2"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="4">
										<v-text-field v-if="admin || isExternalEntity" v-model="product.information[language].tongue" :label="$gettext('Tongue')" outlined class="px-2"></v-text-field>
										<v-text-field v-else v-model="product.tongue" :label="$gettext('Tongue')" outlined class="px-2"></v-text-field>
									</v-col>
									<v-col cols="12" md="4">
										<v-text-field v-if="admin || isExternalEntity" v-model="product.information[language].pulse" :label="$gettext('Pulse')" outlined class="px-2"></v-text-field>
										<v-text-field v-else v-model="product.pulse" :label="$gettext('Pulse')" outlined class="px-2"></v-text-field>
									</v-col>
									<v-col cols="12" md="4">
										<v-text-field
											v-if="admin || isExternalEntity"
											v-model="product.information[language].prep_notes"
											:label="$gettext('Preparation Notes')"
											outlined
											class="px-2"
										></v-text-field>
										<v-text-field
											v-else
											v-model="product.prep_notes"
											:label="$gettext('Preparation Notes')"
											outlined
											class="px-2"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="4">
										<v-text-field
											v-if="admin || isExternalEntity"
											v-model="product.information[language].original"
											:label="$gettext('Original')"
											outlined
											class="px-2"
										></v-text-field>
										<v-text-field
											v-else
											v-model="product.original"
											:label="$gettext('Original')"
											outlined
											class="px-2"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="4">
										<v-text-field
											v-if="admin || isExternalEntity"
											v-model="product.information[language].channels"
											:label="$gettext('Channels')"
											outlined
											class="px-2"
										></v-text-field>
										<v-text-field
											v-else
											v-model="product.channels"
											:label="$gettext('Channels')"
											outlined
											class="px-2"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="4">
										<v-text-field
											v-if="admin || isExternalEntity"
											v-model="product.information[language].western_uses"
											:label="$gettext('Western Uses')"
											outlined
											class="px-2"
										></v-text-field>
										<v-text-field
											v-else
											v-model="product.western_uses"
											:label="$gettext('Western Uses')"
											outlined
											class="px-2"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="4">
										<v-text-field v-if="admin || isExternalEntity" v-model="product.information[language].notes" :label="$gettext('Notes')" outlined class="px-2"></v-text-field>
										<v-text-field v-else v-model="product.notes" :label="$gettext('Notes')" outlined class="px-2"></v-text-field>
									</v-col>
									<v-col cols="12" md="4">
										<v-text-field
											v-model="product.temperature"
											:label="$gettext('Temperature')"
											outlined
											class="px-2"
											:rules="intRules"
										></v-text-field>
									</v-col>
								</v-row>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
				<v-row v-if="type == 'provider'" no-gutters class="mt-4">
					<v-col cols="12" md="12">
						<v-card>
							<v-card-title class="primary--text" v-translate key="provider">Provider</v-card-title>
							<v-card-text>
								<v-row no-gutters>
									<v-col cols="12" sm="4">
										<v-select
											v-model="product.external_entity_id"
											:items="providers"
											:label="$gettext('Provider')"
											item-text="name"
											item-value="id"
											outlined
											class="px-2"
											:rules="requiredRule"
											:disabled="isExternalEntity"
										></v-select>
									</v-col>
									<v-col v-if="product.external_entity_id == -1" cols="12" md="4">
										<v-text-field
											:rules="requiredRule"
											v-model="new_provider"
											:label="$gettext('Name')"
											outlined
										></v-text-field>
									</v-col>
								</v-row>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
				<v-row no-gutters class="mt-4">
					<v-col cols="12" md="12">
						<v-card>
							<v-card-title class="primary--text">
								<translate>Ingredients</translate><v-spacer></v-spacer>
								<!-- <v-checkbox v-if="type == 'provider'" v-model="product.customizable" :label="$gettext('Customizable')" /> -->
							</v-card-title>
							<v-card-text>
								<v-row no-gutters>
									<v-col cols="12" sm="12" class="px-2">
										<SearchSubstances @add-product="addSubstance" :availableProcessing="productProcessing" type="formula" />
									</v-col>
									<v-col cols="12" sm="12" class="mt-4">
										<SubstanceList
											:products="product.ingredients"
											context="new-product"
											type="formula"
											@remove-product="removeSubstance"
											:availableProcessing="productProcessing"
										/>
									</v-col>
								</v-row>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
				<v-row no-gutters class="mt-4">
					<v-col cols="12" md="12">
						<v-card>
							<v-card-title class="primary--text" v-translate>Indications</v-card-title>
							<v-card-text>
								<v-row no-gutters>
									<v-col v-if="admin" cols="12" sm="12" class="px-2">
										<v-textarea
											outlined
											:placeholder="$gettext('Write the product indications')"
											v-model="product.information[language].indications"
										></v-textarea>
									</v-col>
									<v-col cols="12" sm="12" class="mt-4 px-2">
										<SearchICD :selectedICD="product.indications_icd" context="new-product" />
									</v-col>
								</v-row>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
				<v-row no-gutters class="mt-4">
					<v-col cols="12" md="12">
						<v-card>
							<v-card-title class="primary--text" v-translate>Contraindications</v-card-title>
							<v-card-text>
								<v-row no-gutters>
									<v-col v-if="admin" cols="12" sm="12" class="px-2">
										<v-textarea
											outlined
											:placeholder="$gettext('Write the product contraindications')"
											v-model="product.information[language].contraindications"
										></v-textarea>
									</v-col>
									<v-col cols="12" sm="12" class="mt-4 px-2">
										<SearchICD :selectedICD="product.contraindications_icd" context="new-product" />
									</v-col>
								</v-row>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
				<v-row no-gutters class="mt-4">
					<v-col cols="12" md="12">
						<v-card>
							<v-card-title class="primary--text" v-translate>Posology</v-card-title>
							<v-card-text>
								<v-row no-gutters>
									<v-col cols="12" md="4">
										<v-select
											v-model="product.recommendation_quantity.posology_unit_id"
											:items="productUnits"
											:label="$gettext('Unit')"
											item-value="id"
											outlined
											hide-details
											class="px-2"
										>
											<template slot="selection" slot-scope="data">
												{{ data.item.name }} ({{ data.item.code }})
											</template>
											<template slot="item" slot-scope="data">
												{{ data.item.name }} ({{ data.item.code }})
											</template>
										</v-select>
									</v-col>
									<v-col cols="12" md="2" class="my-auto text-center">
										<span class="text-subtitle-1" v-translate>Daily Frequency:</span>
									</v-col>
									<v-col cols="12" md="1">
										<v-text-field
											:label="$gettext('PA')"
											outlined
											hide-details
											v-model="product.recommendation_quantity.morning"
											class="px-3"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="1">
										<v-text-field
											:label="$gettext('MM')"
											outlined
											hide-details
											v-model="product.recommendation_quantity.middle_morning"
											class="px-3"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="1">
										<v-text-field
											:label="$gettext('A')"
											outlined
											hide-details
											v-model="product.recommendation_quantity.half_day"
											class="px-3"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="1">
										<v-text-field
											:label="$gettext('MT')"
											outlined
											hide-details
											v-model="product.recommendation_quantity.middle_afternoon"
											class="px-3"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="1">
										<v-text-field
											:label="$gettext('J')"
											outlined
											hide-details
											v-model="product.recommendation_quantity.night"
											class="px-3"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="3" class="mt-5">
										<v-text-field
											label=">16 (Min)"
											outlined
											hide-details
											v-model="product.recommendation_quantity.over16_min"
											class="px-2"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="3" class="mt-5">
										<v-text-field
											label="12-15 (Min)"
											outlined
											hide-details
											v-model="product.recommendation_quantity.between12_15_min"
											class="px-2"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="3" class="mt-5">
										<v-text-field
											label="6-11 (Min)"
											outlined
											hide-details
											v-model="product.recommendation_quantity.between6_11_min"
											class="px-2"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="3" class="mt-5">
										<v-text-field
											label="<6 (Min)"
											outlined
											hide-details
											v-model="product.recommendation_quantity.under6_min"
											class="px-2"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="3" class="mt-5">
										<v-text-field
											label=">16 (Max)"
											outlined
											hide-details
											v-model="product.recommendation_quantity.over16_max"
											class="px-2"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="3" class="mt-5">
										<v-text-field
											label="12-15 (Max)"
											outlined
											hide-details
											v-model="product.recommendation_quantity.between12_15_max"
											class="px-2"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="3" class="mt-5">
										<v-text-field
											label="6-11 (Max)"
											outlined
											hide-details
											v-model="product.recommendation_quantity.between6_11_max"
											class="px-2"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="3" class="mt-5">
										<v-text-field
											label="<6 (Max)"
											outlined
											hide-details
											v-model="product.recommendation_quantity.under6_max"
											class="px-2"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="3" class="mt-5">
										<v-text-field
											:label="$gettext('Pregnant')"
											outlined
											hide-details
											v-model="product.recommendation_quantity.pos_pregnant"
											class="px-2"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="3" class="mt-5">
										<v-text-field
											:label="$gettext('Lactant')"
											outlined
											hide-details
											v-model="product.recommendation_quantity.pos_lactant"
											class="px-2"
										></v-text-field>
									</v-col>
								</v-row>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
				<v-row v-if="type == 'substance'" no-gutters class="mt-4">
					<v-col cols="12" md="12">
						<v-card>
							<v-card-title class="primary--text" v-translate>Drug Interactions</v-card-title>
							<v-card-text>
								<v-row no-gutters>
									<v-col cols="12" sm="12" class="px-2">
										<v-textarea
											outlined
											:placeholder="$gettext('Write the substance interactions')"
											v-model="product.interactions"
										></v-textarea>
									</v-col>
									<v-col cols="12" sm="12" class="mt-4 px-2">
										<SearchDrugs :selectedDrugs="product.drugs" context="new-product" />
									</v-col>
								</v-row>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
				<v-row no-gutters class="mt-4">
					<v-col cols="12" sm="12">
						<v-btn v-if="edit" color="primary" class="float-right ml-2" @click="editProduct" :loading="saving">
							<translate>Save</translate>
						</v-btn>
						<v-btn v-else color="primary" class="float-right ml-2" @click="createProduct" :loading="saving">
							<translate>Create</translate>
						</v-btn>
						<v-btn color="primary" class="float-right" :to="{name: 'cmm'}">
							<translate>Cancel</translate>
						</v-btn>
					</v-col>
				</v-row>
			</v-form>
		</div>
	</div>
</template>

<script>
import SubstanceList from "@/components/products/SubstanceList.vue";
import SearchProducts from "@/components/products/SearchProducts.vue";
import SearchSubstances from "@/components/products/SearchSubstances.vue";
import SearchICD from "@/components/icd/SearchICD.vue";
import SearchDrugs from "@/components/drugs/SearchDrugs.vue";
import axios from "axios";

export default {
	name: "FormulaForm",
	props: {
		product: {
			default: () => ({
				name: null,
				revision: false,
				discontinued: false,
				visible: true,
				translation: null,
				sub_category: null,
				pattern: null,
				actions: null,
				tongue: null,
				pulse: null,
				prep_notes: null,
				original: null,
				channels: null,
				western_uses: null,
				notes: null,
				temperature: null,
				classic: null,
				from_lab: null,
				lab_formula_id: null,
				external_entity_id: null,
				ingredients: [],
				indications_icd: [],
				contraindications_icd: [],
				drugs: [],
				information: {
					pt: {
						language: "pt",
						name: null,
						translation: null,
						sub_category: null,
						pattern: null,
						actions: null,
						tongue: null,
						pulse: null,
						prep_notes: null,
						original: null,
						channels: null,
						western_uses: null,
						notes: null,
						indications: null,
						contraindications: null,
						interactions: null
					},
					en: {
						language: "en",
						name: null,
						translation: null,
						sub_category: null,
						pattern: null,
						actions: null,
						tongue: null,
						pulse: null,
						prep_notes: null,
						original: null,
						channels: null,
						western_uses: null,
						notes: null,
						indications: null,
						contraindications: null,
						interactions: null
					},
					es: {
						language: "es",
						name: null,
						translation: null,
						sub_category: null,
						pattern: null,
						actions: null,
						tongue: null,
						pulse: null,
						prep_notes: null,
						original: null,
						channels: null,
						western_uses: null,
						notes: null,
						indications: null,
						contraindications: null,
						interactions: null
					}
				},
				recommendation_quantity: {
					posology_unit_id: 2,
					morning: null,
					middle_morning: null,
					half_day: null,
					middle_afternoon: null,
					night: null,
					over16_min: null,
					between12_15_min: null,
					between6_11_min: null,
					under6_min: null,
					over16_max: null,
					between12_15_max: null,
					between6_11_max: null,
					under6_max: null,
					pos_pregnant: null,
					pos_lactant: null
				}
			})
		},
		edit: {
			default: false
		},
		providers: {
			default: () => []
		},
		productUnits: {
			default: () => []
		},
		productProcessing: {
			default: () => []
		},
		admin: {
			default: false
		}
	},
	components: {
		SubstanceList,
		SearchProducts,
		SearchSubstances,
		SearchICD,
		SearchDrugs
	},
	data: () => ({
		language: "pt",
		type: "classic",
		new_provider: null,
		saving: false,
		generalFormValid: false,
		success: false,
		error: false,
		showImportProduct: false
	}),
	computed: {
		intRules() {
			return [v => this.isInt(Number(v)) || this.$gettext("Invalid number")];
		},
		requiredRule() {
			return [v => !!v || this.$gettext("Required")];
		},
		availableLanguages() {
			return [
				{ code: "en", name: "English" },
				{ code: "pt", name: "Português" },
				{ code: "es", name: "Espanol" }
			];
		},
		availableSubstanceTypes() {
			return [
				{ name: this.$gettext("Mineral"), code: "mineral" },
				{ name: this.$gettext("Plant"), code: "plant" },
				{ name: this.$gettext("Vitamin"), code: "vitamin" },
				{ name: this.$gettext("Excipient"), code: "excipient" },
				{ name: this.$gettext("Other"), code: "other" }
			];
		},
		availablePlantParts() {
			return [
				{ name: this.$gettext("Root"), code: "raiz" },
				{ name: this.$gettext("Leaf"), code: "folha" },
				{ name: this.$gettext("Flower"), code: "flor" }
			];
		},
		isExternalEntity() {
			return this.$store.getters.isExternalEntity;
		}
	},
	methods: {
		isInt(n) {
			console.log(n);
			if (n == 0) return true;
			if (n) {
				return Number(n) === n && n % 1 === 0;
			}
			return false;
		},
		addSubstance(substance) {
			//CALL API
			if (substance) {
				var exist = false;
				for (var i = 0; i < this.product.ingredients.length; i++) {
					if (this.product.ingredients[i].id == substance.product.id) {
						exist = true;
						break;
					}
				}
				if (!exist) {
					//CALL API
					console.log("ADD SUBSTANCE");
					this.product.ingredients.push(substance);
				}
			}
		},
		removeSubstance(substance) {
			this.product.ingredients.splice(
				this.product.ingredients.indexOf(substance),
				1
			);
		},
		editProduct() {
			this.success = false;
			this.error = false;
			if (this.validateForms()) {
				this.saving = true;
				const form = this.getForm();
				const productId = this.$route.params.sid;
				axios
					.post("/mtc/formulas/" + productId + "/edit", form)
					.then(response => {
						console.log(response.data);
						window.scrollTo(0, 0);
						this.saving = false;
						if (response.data === "OK") {
							if (this.admin) {
								window.scrollTo(0, 0);
								this.success = true;
							} else {
								this.$router.push({
									name: "cmm"
								});
							}
						} else {
							window.scrollTo(0, 0);
							this.error = true;
						}
					})
					.catch(error => {
						window.scrollTo(0, 0);
						this.saving = false;
						this.error = true;
						console.log(error);
					});
			} else {
				window.scrollTo(0, 0);
			}
		},
		createProduct() {
			this.success = false;
			this.error = false;
			if (this.validateForms()) {
				this.saving = true;
				const form = this.getForm();
				axios
					.post("/mtc/formulas/new", form)
					.then(response => {
						console.log(response.data);
						window.scrollTo(0, 0);
						this.saving = false;
						if (response.data === "OK") {
							this.success = true;
							if (this.admin) {
								console.log("CREATED");
								this.$router.push({
									name: "admin-cmm",
									params: { admin: true }
								});
							} else {
								this.$router.push({
									name: "cmm"
								});
							}
						} else {
							this.error = true;
						}
					})
					.catch(error => {
						window.scrollTo(0, 0);
						this.saving = false;
						this.error = true;
						console.log(error);
					});
			} else {
				window.scrollTo(0, 0);
			}
		},
		validateForms() {
			return this.$refs.generalForm.validate();
		},
		getForm() {
			const formData = new FormData();
			if (!this.edit) {
				var classic = false;
				if (this.type === "classic") classic = true;
				formData.append("classic", classic);
			} else {
				formData.append("classic", this.product.classic);
			}
			if (this.product.revision) {
				formData.append("revision", true);
			} else {
				formData.append("revision", false);
			}
			formData.append("discontinued", this.product.discontinued);
			formData.append("visible", this.product.visible);
			formData.append("name", this.product.name);
			if (this.product.translation) {
				formData.append("translation", this.product.translation);
			}
			if (this.product.sub_category) {
				formData.append("sub_category", this.product.sub_category);
			}
			if (this.product.pattern) {
				formData.append("pattern", this.product.pattern);
			}
			if (this.product.presentation) {
				formData.append("presentation", this.product.presentation);
			}
			if (this.product.actions) {
				formData.append("actions", this.product.actions);
			}
			if (this.product.tongue) {
				formData.append("tongue", this.product.tongue);
			}
			if (this.product.pulse) {
				formData.append("pulse", this.product.pulse);
			}
			if (this.product.prep_notes) {
				formData.append("prep_notes", this.product.prep_notes);
			}
			if (this.product.original) {
				formData.append("original", this.product.original);
			}
			if (this.product.channels) {
				formData.append("channels", this.product.channels);
			}
			if (this.product.western_uses) {
				formData.append("western_uses", this.product.western_uses);
			}
			if (this.product.temperature) {
				formData.append("temperature", this.product.temperature);
			}
			if (this.product.notes) {
				formData.append("notes", this.product.notes);
			}
			if (this.product.external_entity_id) {
				formData.append("provider", this.product.external_entity_id);
				if (this.product.external_entity_id == -1) {
					formData.append("new_provider", this.new_provider);
				}
			}
			//Posology frequency
			if (this.product.recommendation_quantity.morning != null) {
				formData.append("morning", this.product.recommendation_quantity.morning);
			}
			if (this.product.recommendation_quantity.middle_morning != null) {
				formData.append("middle_morning", this.product.recommendation_quantity.middle_morning);
			}
			if (this.product.recommendation_quantity.half_day != null) {
				formData.append("half_day", this.product.recommendation_quantity.half_day);
			}
			if (this.product.recommendation_quantity.middle_afternoon != null) {
				formData.append("middle_afternoon", this.product.recommendation_quantity.middle_afternoon);
			}
			if (this.product.recommendation_quantity.night != null) {
				formData.append("night", this.product.recommendation_quantity.night);
			}
			//Posology limitations
			if (this.product.recommendation_quantity.over16_min != null) {
				formData.append("over16_min", this.product.recommendation_quantity.over16_min);
			}
			if (this.product.recommendation_quantity.over16_max != null) {
				formData.append("over16_max", this.product.recommendation_quantity.over16_max);
			}
			if (this.product.recommendation_quantity.under6_max != null) {
				formData.append("under6_max", this.product.recommendation_quantity.under6_max);
			}
			if (this.product.recommendation_quantity.under6_min != null) {
				formData.append("under6_min", this.product.recommendation_quantity.under6_min);
			}
			if (this.product.recommendation_quantity.between12_15_min != null) {
				formData.append("between12_15_min", this.product.recommendation_quantity.between12_15_min);
			}
			if (this.product.recommendation_quantity.between12_15_max != null) {
				formData.append("between12_15_max", this.product.recommendation_quantity.between12_15_max);
			}
			if (this.product.recommendation_quantity.between6_11_min != null) {
				formData.append("between6_11_min", this.product.recommendation_quantity.between6_11_min);
			}
			if (this.product.recommendation_quantity.between6_11_max != null) {
				formData.append("between6_11_max", this.product.recommendation_quantity.between6_11_max);
			}
			if (this.product.recommendation_quantity.pos_pregnant != null) {
				formData.append("pos_pregnant", this.product.recommendation_quantity.pos_pregnant);
			}
			if (this.product.recommendation_quantity.pos_lactant != null) {
				formData.append("pos_lactant", this.product.recommendation_quantity.pos_lactant);
			}
			if (this.product.recommendation_quantity.posology_unit_id != null) {
				formData.append("posology_unit_id", this.product.recommendation_quantity.posology_unit_id);
			}
			var ingredients = {};
			this.product.ingredients.forEach(i => {
				ingredients[i.product.id] = { quantity: i.quantity, unit: i.unit, processing: i.processing, info: i.info };
			});
			formData.append("ingredients_json", JSON.stringify(ingredients));
			//Indications
			var indications_icd = [];
			this.product.indications_icd.forEach(icd => {
				indications_icd.push({disease_id: icd.disease_id, degree: icd.degree});
			});
			formData.append("indications_json", JSON.stringify(indications_icd));
			//if (this.product.indications != null) {
			//	formData.append("indications", this.product.indications);
			//}
			//Contraindications
			var contraindications_icd = [];
			this.product.contraindications_icd.forEach(icd => {
				contraindications_icd.push({disease_id: icd.disease_id, degree: icd.degree});
			});
			formData.append("contraindications_json", JSON.stringify(contraindications_icd));
			//if (this.product.contraindications != null) {
			//	formData.append("contraindications", this.product.contraindications);
			//}
			//var drugs = [];
			//this.product.drugs.forEach(d => {
			//	drugs.push(d.id);
			//});
			//formData.append("drugs_json", JSON.stringify(drugs));
			//if (this.product.interactions != null) {
			//	formData.append("interactions", this.product.interactions);
			//}

			var information = [];
			for (const [key, value] of Object.entries(this.product.information)) {
				console.log(key);
				information.push(value);
			}
			formData.append("information_json", JSON.stringify(information));

			console.log(information, ingredients, indications_icd, contraindications_icd);
			return formData;
		},
		importProduct(productId) {
			this.saving = true;
			axios
				.get("/mtc/formulas/" + productId + "/edit")
				.then(response => {
					this.saving = false;
					this.product = response.data.product;
				})
				.catch(error => {
					console.log(error);
					this.saving = false;
				});
		}
	},
	updated() {
		if (this.edit) {
			if (this.product.from_lab == true) {
				this.type = "provider";
			} else {
				this.type = "classic";
			}
		}
	},
	created() {
		if(!this.edit && this.isExternalEntity) {
			this.type = "provider";
			this.product.external_entity_id = this.$store.getters.externalEntity.id;
		}
	}
};
</script>